import BaseComponent from './BaseComponent';

class Header extends BaseComponent {
  constructor(componentName){
    super(componentName);
    this.lastIndexUsed = null;
  }

  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    // console.log('component', component.id);
    this.addShapes(component.element);
  }


  addShapes(element) {
    const shapesArea = element.getElementsByClassName('shapes-area')[0];
    const combinationHome = [
      [{ left: 20, right: 'auto', deg: 90, x: -98, y: 80 }, { left: 50, right: 50, deg: 270, x:-50, y: 280 }, { left: 'auto', right: 7, deg: 0, x: 20, y: 18 }],
      [{ left: 20, right: 'auto', deg: 90, x: -80, y: 206 }, { left: 50, right: 50, deg: 180, x:-50, y: -5 }, { left: 'auto', right: 10, deg: 0, x: 34, y: 200 }],
      [{ left: 5, right: 'auto', deg: 90, x: -39, y: 0 }, { left: 50, right: 50, deg: 0, x:-50, y: 180 }, { left: 'auto', right: 5, deg: 0, x: 75, y: 73 }]
    ];

    const combinationCategories = [
      [{ left: 0, right: 'auto', deg: 90, x: -12, y: 20 }, { left: 'auto', right: 0, deg: 270, x:-50, y: 60 }],
      [{ left: 0, right: 'auto', deg: 270, x: 60, y: 270 }, { left: 'auto', right: 0, deg: 40, x: -50, y: 160 }],
      [{ left: 0, right: 'auto', deg: 0, x: 155, y: 200 }, { left: 'auto', right: 0, deg: 100, x: -50, y: -10 }],
      [{ left: 0, right: 'auto', deg: 0, x: 70, y: 180 }, { left: 'auto', right: 0, deg: 0, x: -50, y: 50 }],
      [{ left: 0, right: 'auto', deg: 60, x: 123, y: 23 }, { left: 'auto', right: 0, deg: 0, x: -50, y: 23 }],
      [{ left: 0, right: 'auto', deg: 40, x: -30, y: 160 }, { left: 'auto', right: 0, deg: 0, x: -50, y: 50 }],
      [{ left: 0, right: 'auto', deg: 90, x: -45, y: 80 }, { left: 'auto', right: 0, deg: 100, x: -50, y: -10 }]
    ];

    //Take number of shapes
    let numberOfShapes = parseInt(element.getAttribute('data-shapes-number'));
    // point to the right array
    const arrayOfCombinations = numberOfShapes ? combinationHome : combinationCategories;

    for(let [index, combination] of arrayOfCombinations.entries()) {
      if((typeof this.lastIndexUsed) == 'number' && index > this.lastIndexUsed) {
        this.getValues(shapesArea, combination, index);
        break;
      } else if (!this.lastIndexUsed && this.lastIndexUsed !== 0) {
        this.getValues(shapesArea, combination, index);
        break;
      } else if (this.lastIndexUsed == arrayOfCombinations.length - 1) {
        this.getValues(shapesArea, combination, 0);
        break;
      }
    }
  }

  getValues(shapesArea, combination, index) {
    for (let shapeValues of combination) {
      this.drawShape(shapesArea, shapeValues);
    }
    this.lastIndexUsed = index;
  }


  drawShape(shapesArea, values) {
    if(!!shapesArea & !!values) {
      const string  = `
      <div class='img-wrapper' style='
      left: ${values.left}${values.left == 'auto' ? '' : values.left == 0 ? '' : 'vw'};
      right: ${values.right}${values.right == 'auto' ? '' : values.right == 0 ? '' : 'vw'};
      transform: translate(${values.x}%,${values.y}%) rotate(${values.deg}deg);'>
        <img src='/assets/front/header_bg--circle.svg' draggable='off' alt='Silver Sanz - draggable icon'>
      </div>
      `;

      shapesArea.appendChild(app.parser.parseToHTML(string))
    }
  }


  generateRandomPosition() {
    const self = this;
    function getRandomNumber(arr) {
      const randomNumber = getRandomNumberBetween(0, 4);
      if(!!arr[randomNumber]) {
        return arr.splice(randomNumber, 1)[0];
      } else {
        return getRandomNumber(arr);
      }
    }

    return {
      x: getRandomNumber(self.xOptions),
      y: getRandomNumber(self.yOptions),
      deg: getRandomNumber(self.degOptions)
    };
  }

}

export default Header;
